// src/components/home/PostActions.tsx
import React from 'react';
import { FaHeart, FaComment, FaPaperPlane, FaBookmark } from 'react-icons/fa';
 
interface PostActionsProps {
  darkMode: boolean;
  postId: string;
  likes: number;
  commentsCount: number;
  shares: number;
  isLiked: boolean;
  isSaved: boolean;
  isOptimistic: boolean;
  showComments: boolean;
  onLike: () => void;
  onToggleComments: () => void;
  onShare: () => void;
  onToggleSave: () => void;
  formatCount: (count: number) => string;
}
 
export const PostActions: React.FC<PostActionsProps> = ({
  darkMode, likes, commentsCount, shares,
  isLiked, isSaved, isOptimistic, showComments,
  onLike, onToggleComments, onShare, onToggleSave, formatCount,
}) => {
  const mutedColor = darkMode ? 'rgba(126,206,206,0.35)' : 'rgba(13,26,26,0.4)';
  const activeColor = '#e8a820';
  const disabledStyle = isOptimistic ? { opacity: 0.5, cursor: 'not-allowed' as const } : {};
 
  return (
    <div className="px-5 pb-4 pt-1">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          {/* Like */}
          <button
            onClick={onLike}
            disabled={isOptimistic}
            className="flex items-center gap-2 transition-all"
            style={{ color: isLiked ? activeColor : mutedColor, ...disabledStyle }}
          >
            <FaHeart style={{ fontSize: '16px' }} />
            <span className="text-xs font-bold" style={{ letterSpacing: '0.5px' }}>{formatCount(likes)}</span>
          </button>
 
          {/* Comment */}
          <button
            onClick={onToggleComments}
            disabled={isOptimistic}
            className="flex items-center gap-2 transition-all"
            style={{ color: showComments ? activeColor : mutedColor, ...disabledStyle }}
          >
            <FaComment style={{ fontSize: '16px' }} />
            <span className="text-xs font-bold" style={{ letterSpacing: '0.5px' }}>{formatCount(commentsCount)}</span>
          </button>
 
          {/* Share */}
          <button
            onClick={onShare}
            disabled={isOptimistic}
            className="flex items-center gap-2 transition-all"
            style={{ color: mutedColor, ...disabledStyle }}
          >
            <FaPaperPlane style={{ fontSize: '16px' }} />
            <span className="text-xs font-bold" style={{ letterSpacing: '0.5px' }}>{formatCount(shares)}</span>
          </button>
        </div>
 
        {/* Save */}
        <button
          onClick={onToggleSave}
          disabled={isOptimistic}
          className="transition-all"
          style={{ color: isSaved ? activeColor : mutedColor, ...disabledStyle }}
        >
          <FaBookmark style={{ fontSize: '16px' }} />
        </button>
      </div>
    </div>
  );
};
 